module.exports = __webpack_public_path__ + "static/workplace-lessons-from-the-pandemic-11406e4a5876e1376376cc545ab62805.jpg";